import { Button, EmptyState, LogoMark } from "@ml/ui";
import { RefreshCw, TriangleAlert } from "lucide-react";
import { isRouteErrorResponse, useRouteError } from "react-router";

/** Router error boundary. `inline` renders inside the app layout; otherwise full screen. */
export function RouteError({ inline = false }: { inline?: boolean }) {
  const err = useRouteError();
  const message = isRouteErrorResponse(err)
    ? `${err.status} ${err.statusText}`
    : err instanceof Error
      ? err.message
      : "Unknown error";
  // Stale chunk after a deploy: a reload fetches the new build.
  const isChunkError = /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(message);
  const body = (
    <EmptyState
      size="lg"
      icon={<TriangleAlert />}
      title={isChunkError ? "Magically Linked was just updated." : "Something broke on this page."}
      description={
        isChunkError
          ? "Reload to get the latest version."
          : `Reloading usually fixes it. If it keeps happening, send us this: ${message}`
      }
      action={
        <Button variant="primary" icon={<RefreshCw size={16} />} onClick={() => window.location.reload()}>
          Reload
        </Button>
      }
    />
  );
  if (inline) return <div className="gfp-center-page">{body}</div>;
  return (
    <div className="gfp-splash">
      <LogoMark size={48} title="" />
      {body}
    </div>
  );
}
